export enum ErrorCode {
  CustomDomainError = 'CustomDomainError',
  DomainCanNotAccess = 'DomainCanNotAccess',
  Unknown = 'Unknown',
  Unpublish = '404001',
  Unauthorized = '401000',
  Expired = '404010',
  NotExisted = 'NotExisted',
  NetworkError = 'NetworkError',
  InvalidPath = 'InvalidPath',
}
